import React, { useState, useContext } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal.jsx";

const StatsLatencyHelpModal = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);
  actions.recv("open-help", function () {
    setOpen(true);
  });
  const doClose = () => setOpen(false);
  if (open !== true) {
    return null;
  }

  return (
    <Modal
      title="Latency Over Time"
      onClose={doClose}
      content={() => (
        <>
           <p>RTT (Round-trip time) latency over time, measured with TCP acknowledgements, from the time data packets leave this node towards the end user until the acknowledgements are received by this node. It does not include the latency from this node to the servers in Internet. Each measurement is calculated over a 5-minute interval.
           </p>
          <p>Chart selectors:</p>
          <ul>
            <li>
              <i className="material-icons valign-icon">date_range</i> Selects the
              range of time values shown starting from now: 1 day, 1 week or 1
              month. The slider at the bottom of the graph allows refining the
              range of date values shown: a shorter interval by dragging any of
              the dated labels and, once done, by dragging the central part.
            </li>
            <li><i className="material-icons valign-icon">insert_chart</i>Select the metric to display, with the following options:
        <ul>
          <li>P80-80th percentile: <br />The 80-th percentile of all downlink RTT latency samples in 5 minutes.</li>
          <li>P50-Median:<br /> The 50-th percentile (ie, the median) of all downlink RTT latency samples in 5 minutes.</li>
          <li>Mean-Min:<br /> The mean of all downlink RTT minimum latency samples, measured in 1-second intervals, during active downloads, in 5 minutes.</li>
          <li>All:<br /> Show all the above metrics</li>
        </ul>
        </li>
          </ul>

          <p>
            Click on the <i className="material-icons valign-icon">refresh</i> icon
            to refresh the data.
          </p>
        </>
      )}
      onClose={doClose}
    />
  );
};
export default StatsLatencyHelpModal;
